var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"menu-se-connecter"},[_c('router-link',{attrs:{"to":"/signin","title":"Se connecter à votre compte COOLOC"}},[_c('svgicon',{staticClass:"connect-icon",attrs:{"icon":"profile-user"}}),_vm._v(" "),_c('span',[_vm._v("Se connecter")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }